'use client'

import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import { useLocation } from '@marketplace-web/shared/browser'
import { useTracking } from '@marketplace-web/shared/event-tracker'
import { urlWithParams } from '@marketplace-web/shared/utils'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'

import { clickEvent } from '_libs/common/event-tracker/events'
import { TRANSACTION_FAQ_ENTRY_URL } from 'constants/routes'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { TrackingChannel } from 'constants/tracking/tracking-channels'

type Props = ConversationActionProps

const ReportProblem = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { transaction } = useConversationContext()

  const { relativeUrl } = useLocation()

  const trackReportProblem = () => {
    const targetDetails = {
      transaction_id: transaction?.id,
    }

    track(
      clickEvent({
        target: ClickableElement.IHaveAnIssue,
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  if (!transaction?.id) return null

  const problemReportUrl = urlWithParams(TRANSACTION_FAQ_ENTRY_URL(transaction?.id), {
    ref_url: relativeUrl,
    ch: TrackingChannel.Conversation,
    related_only: true,
  })

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={problemReportUrl}
      onClick={trackReportProblem}
      testId="conversation-action--report-problem-button"
    />
  )
}

export default ReportProblem
